// extracted by mini-css-extract-plugin
module.exports = {"vWhite1":"#f2f2fa","vGray1":"#83929c","item":"SuggestField_item__3trSx","highlight":"SuggestField_highlight__2H9z3"};